import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUzFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_68_15363)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0001 19.5403H0.000244141V9.48279C0.000244141 9.00672 0.386279 8.62068 0.862352 8.62068H49.1381C49.6142 8.62068 50.0002 9.00672 50.0002 9.48279L50.0001 19.5403Z",
					fill: "#82AFFF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.138 41.3793H0.862352C0.386279 41.3793 0.000244141 40.9933 0.000244141 40.5172V30.4598H50.0001V40.5172C50.0001 40.9934 49.6141 41.3793 49.138 41.3793Z",
					fill: "#73AF00"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0001 19.5401H0.000244141V30.4591H50.0001V19.5401Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0001 18.5704H0.000244141V19.9319H50.0001V18.5704Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0004 30.0674H0.000488281V31.4289H50.0004V30.0674Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.0832 16.8039C9.31833 16.8039 7.88776 15.3768 7.88776 13.6183C7.88776 11.8533 9.31823 10.4197 11.0832 10.4197C11.09 10.4197 11.0966 10.4197 11.1033 10.4198C11.2072 10.4212 11.2436 10.2832 11.152 10.2341C10.6086 9.94278 9.98834 9.77794 9.32897 9.78272C7.21726 9.79776 5.50193 11.5477 5.52439 13.6594C5.54646 15.7493 7.25505 17.441 9.35661 17.441C10.0069 17.441 10.6184 17.2765 11.1551 16.9892C11.2464 16.9402 11.2095 16.8022 11.106 16.8037C11.0982 16.8039 11.0907 16.8039 11.0832 16.8039Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.5848 15.923L13.4422 16.351L12.9911 16.3544C12.9327 16.3548 12.9085 16.4294 12.9554 16.464L13.3183 16.732L13.1822 17.1621C13.1646 17.2178 13.228 17.2638 13.2756 17.2299L13.6426 16.9676L14.0095 17.2299C14.0571 17.2638 14.1204 17.2178 14.1029 17.1621L13.9668 16.732L14.3296 16.464C14.3765 16.4294 14.3523 16.3548 14.2939 16.3544L13.8428 16.351L13.7002 15.923C13.6817 15.8677 13.6034 15.8677 13.5848 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.7629 15.923L16.6203 16.351L16.1692 16.3544C16.1108 16.3548 16.0866 16.4294 16.1335 16.464L16.4963 16.732L16.3602 17.1621C16.3426 17.2178 16.406 17.2638 16.4536 17.2299L16.8206 16.9676L17.1876 17.2299C17.2351 17.2638 17.2984 17.2178 17.2809 17.1621L17.1448 16.732L17.5076 16.464C17.5545 16.4294 17.5303 16.3548 17.4719 16.3544L17.0209 16.351L16.8782 15.923C16.8597 15.8677 16.7813 15.8677 16.7629 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9408 15.923L19.7981 16.351L19.347 16.3544C19.2886 16.3548 19.2644 16.4294 19.3114 16.464L19.6743 16.732L19.5382 17.1621C19.5206 17.2178 19.584 17.2638 19.6315 17.2299L19.9985 16.9676L20.3655 17.2299C20.4131 17.2638 20.4763 17.2178 20.4589 17.1621L20.3227 16.732L20.6855 16.464C20.7325 16.4294 20.7083 16.3548 20.6499 16.3544L20.1988 16.351L20.0561 15.923C20.0377 15.8677 19.9593 15.8677 19.9408 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.1185 15.923L22.9759 16.351L22.5248 16.3544C22.4664 16.3548 22.4422 16.4294 22.4891 16.464L22.8519 16.732L22.7158 17.1621C22.6982 17.2178 22.7616 17.2638 22.8092 17.2299L23.1761 16.9676L23.5431 17.2299C23.5907 17.2638 23.654 17.2178 23.6365 17.1621L23.5004 16.732L23.8632 16.464C23.9101 16.4294 23.8859 16.3548 23.8275 16.3544L23.3764 16.351L23.2338 15.923C23.2154 15.8677 23.137 15.8677 23.1185 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2968 15.923L26.1541 16.351L25.703 16.3544C25.6446 16.3548 25.6204 16.4294 25.6674 16.464L26.0302 16.732L25.8941 17.1621C25.8765 17.2178 25.9399 17.2638 25.9875 17.2299L26.3545 16.9676L26.7215 17.2299C26.769 17.2638 26.8323 17.2178 26.8148 17.1621L26.6787 16.732L27.0416 16.464C27.0885 16.4294 27.0643 16.3548 27.0059 16.3544L26.5549 16.351L26.4122 15.923C26.3935 15.8677 26.3152 15.8677 26.2968 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.7629 12.957L16.6203 13.3849L16.1692 13.3883C16.1108 13.3887 16.0866 13.4633 16.1335 13.498L16.4963 13.766L16.3602 14.1961C16.3426 14.2517 16.406 14.2978 16.4536 14.2638L16.8206 14.0015L17.1876 14.2638C17.2351 14.2978 17.2984 14.2517 17.2809 14.1961L17.1448 13.766L17.5076 13.498C17.5545 13.4633 17.5303 13.3887 17.4719 13.3883L17.0209 13.3849L16.8782 12.957C16.8597 12.9014 16.7813 12.9014 16.7629 12.957Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9408 12.957L19.7981 13.3849L19.347 13.3883C19.2886 13.3887 19.2644 13.4633 19.3114 13.498L19.6743 13.766L19.5382 14.1961C19.5206 14.2517 19.584 14.2978 19.6315 14.2638L19.9985 14.0015L20.3655 14.2638C20.4131 14.2978 20.4763 14.2517 20.4589 14.1961L20.3227 13.766L20.6855 13.498C20.7325 13.4633 20.7083 13.3887 20.6499 13.3883L20.1988 13.3849L20.0561 12.957C20.0377 12.9014 19.9593 12.9014 19.9408 12.957Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.1185 12.957L22.9759 13.3849L22.5248 13.3883C22.4664 13.3887 22.4422 13.4633 22.4891 13.498L22.8519 13.766L22.7158 14.1961C22.6982 14.2517 22.7616 14.2978 22.8092 14.2638L23.1761 14.0015L23.5431 14.2638C23.5907 14.2978 23.654 14.2517 23.6365 14.1961L23.5004 13.766L23.8632 13.498C23.9101 13.4633 23.8859 13.3887 23.8275 13.3883L23.3764 13.3849L23.2338 12.957C23.2154 12.9014 23.137 12.9014 23.1185 12.957Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2968 12.957L26.1541 13.3849L25.703 13.3883C25.6446 13.3887 25.6204 13.4633 25.6674 13.498L26.0302 13.766L25.8941 14.1961C25.8765 14.2517 25.9399 14.2978 25.9875 14.2638L26.3545 14.0015L26.7215 14.2638C26.769 14.2978 26.8323 14.2517 26.8148 14.1961L26.6787 13.766L27.0416 13.498C27.0885 13.4633 27.0643 13.3887 27.0059 13.3883L26.5549 13.3849L26.4122 12.957C26.3935 12.9014 26.3152 12.9014 26.2968 12.957Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9408 15.923L19.7981 16.351L19.347 16.3544C19.2886 16.3548 19.2644 16.4294 19.3114 16.464L19.6743 16.732L19.5382 17.1621C19.5206 17.2178 19.584 17.2638 19.6315 17.2299L19.9985 16.9676L20.3655 17.2299C20.4131 17.2638 20.4763 17.2178 20.4589 17.1621L20.3227 16.732L20.6855 16.464C20.7325 16.4294 20.7083 16.3548 20.6499 16.3544L20.1988 16.351L20.0561 15.923C20.0377 15.8677 19.9593 15.8677 19.9408 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M19.9408 9.99085L19.7981 10.4188L19.347 10.4222C19.2886 10.4226 19.2644 10.4972 19.3114 10.5319L19.6743 10.7998L19.5382 11.2299C19.5206 11.2856 19.584 11.3317 19.6315 11.2977L19.9985 11.0354L20.3655 11.2977C20.4131 11.3317 20.4763 11.2856 20.4589 11.2299L20.3227 10.7998L20.6855 10.5319C20.7325 10.4972 20.7083 10.4226 20.6499 10.4222L20.1988 10.4188L20.0561 9.99085C20.0377 9.93548 19.9593 9.93548 19.9408 9.99085Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.1185 15.923L22.9759 16.351L22.5248 16.3544C22.4664 16.3548 22.4422 16.4294 22.4891 16.464L22.8519 16.732L22.7158 17.1621C22.6982 17.2178 22.7616 17.2638 22.8092 17.2299L23.1761 16.9676L23.5431 17.2299C23.5907 17.2638 23.654 17.2178 23.6365 17.1621L23.5004 16.732L23.8632 16.464C23.9101 16.4294 23.8859 16.3548 23.8275 16.3544L23.3764 16.351L23.2338 15.923C23.2154 15.8677 23.137 15.8677 23.1185 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2968 15.923L26.1541 16.351L25.703 16.3544C25.6446 16.3548 25.6204 16.4294 25.6674 16.464L26.0302 16.732L25.8941 17.1621C25.8765 17.2178 25.9399 17.2638 25.9875 17.2299L26.3545 16.9676L26.7215 17.2299C26.769 17.2638 26.8323 17.2178 26.8148 17.1621L26.6787 16.732L27.0416 16.464C27.0885 16.4294 27.0643 16.3548 27.0059 16.3544L26.5549 16.351L26.4122 15.923C26.3935 15.8677 26.3152 15.8677 26.2968 15.923Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.1185 9.99085L22.9759 10.4188L22.5248 10.4222C22.4664 10.4226 22.4422 10.4972 22.4891 10.5319L22.8519 10.7998L22.7158 11.2299C22.6982 11.2856 22.7616 11.3317 22.8092 11.2977L23.1761 11.0354L23.5431 11.2977C23.5907 11.3317 23.654 11.2856 23.6365 11.2299L23.5004 10.7998L23.8632 10.5319C23.9101 10.4972 23.8859 10.4226 23.8275 10.4222L23.3764 10.4188L23.2338 9.99085C23.2154 9.93548 23.137 9.93548 23.1185 9.99085Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.2968 9.99085L26.1541 10.4188L25.703 10.4222C25.6446 10.4226 25.6204 10.4972 25.6674 10.5319L26.0302 10.7998L25.8941 11.2299C25.8765 11.2856 25.9399 11.3317 25.9875 11.2977L26.3545 11.0354L26.7215 11.2977C26.769 11.3317 26.8323 11.2856 26.8148 11.2299L26.6787 10.7998L27.0416 10.5319C27.0885 10.4972 27.0643 10.4226 27.0059 10.4222L26.5549 10.4188L26.4122 9.99085C26.3935 9.93548 26.3152 9.93548 26.2968 9.99085Z",
					fill: "#F3F3F3"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_68_15363",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgUzFlag);
export { ForwardRef as ReactComponent };
